<template>
  <div class="collect">
    <div class="big-title">
      <div class="icon"></div>
      <span>比赛详情</span>
    </div>
    <div class="team detail">
      <div class="table">
        <div class="left">
          <div class="label">球队名称</div>
          <div class="name">{{ homeTeamName }}</div>
          <div class="name">{{ awayTeamName }}</div>
        </div>
        <div class="right">
          <div class="label">
            <div style="background: #0352E8" class="Total">总分</div>
            <div class="game-sub" v-for="(item, i) in gameSub" :key="'gameSub' + i"
              :style="{ background: i % 2 === 1 ? '#0352E8' : '#1565FC' }">{{ i + 1 }}</div>
          </div>
          <div class="round">
            <div class="item">
              <div class="Total">{{ homeScore == -1 ? '-' : homeScore }}</div>
              <div class="game-sub" v-for="(item, i) in gameSub" :key="i">
                {{ gameSub[i].homeScore }}
              </div>
            </div>
            <div class="item">
              <div class="Total">{{ awayScore == -1 ? '-' : awayScore }}</div>
              <div class="game-sub" v-for="(item, i) in gameSub" :key="i">
                {{ gameSub[i].awayScore }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="gameMVPId">
      <div class="big-title">
        <div class="icon"></div>
        <span>最佳球员</span>
      </div>
      <div class="mvp">
        <img :src="imageView(mvpObj.avatar)" />
        <div class="info">
          <div class="name">{{ mvpObj.trueName }} ({{ mvpObj.number }})</div>
          <div class="team-name">{{ mvpObj.teamName }}</div>
        </div>
        <img style="height: 30px;width: 92px;margin: 0;" src="https://images.snsports.cn/FhALsiByLK6qel7t2YI3pR-Eh1UP" />
      </div>
    </div>
    <div class="big-title">
      <div class="icon"></div>
      <span>数据统计</span>
    </div>
    <van-tabs background="#FFFFFF" v-model="active" v-if="typeOptions.length > 1">
      <van-tab v-for="item in typeOptions" :name="item.value" :title="item.label" :key="item.value"></van-tab>
    </van-tabs>
    <div class="team">
      <div class="title flex-center" @click="showHome = !showHome">
        <div class="name">{{ homeTeamName }}</div>
        <div class="icon">
          {{ showHome ? '折叠' : '展开' }}
          <van-icon name="arrow-down" size="16px" style="margin-left: 6px;" class="is"
            :class="showHome ? 'van-icon1' : ''" />
        </div>
      </div>
      <div class="table" v-if="showHome">
        <div class="left">
          <div class="label">选手</div>
          <div class="name" v-for="p in homeTeamPlayers" :key="'name' + p.playerId">【{{ p.number }}】{{ p.trueName }}</div>
        </div>
        <div class="right">
          <div class="label" v-if="active === 1">
            <span v-for="(item, i) in attachOptions" :key="'attach' + i">
              <div v-if="attachCheckboxes[item.label]"
                :style="{ background: getColor(attachOptions, attachCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 1">
            <div v-for="player in homeTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in attachOptions" :key="i">
                <div v-if="attachCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
          <div class="label" v-if="active === 2">
            <span v-for="(item, i) in pitchingOptions" :key="'pitching' + i">
              <div v-if="pitchingCheckboxes[item.label]"
                :style="{ background: getColor(pitchingOptions, pitchingCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 2">
            <div v-for="player in homeTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in pitchingOptions" :key="i">
                <div v-if="pitchingCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
          <div class="label" v-if="active === 3">
            <span v-for="(item, i) in catcherOptions" :key="'attach' + i">
              <div v-if="catcherCheckboxes[item.label]"
                :style="{ background: getColor(catcherOptions, catcherCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 3">
            <div v-for="player in homeTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in catcherOptions" :key="i">
                <div v-if="catcherCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="team">
      <div class="title flex-center" @click="showAway = !showAway">
        <div class="name">{{ awayTeamName }}</div>
        <div class="icon">
          {{ showAway ? '折叠' : '展开' }}
          <van-icon name="arrow-down" size="16px" style="margin-left: 6px;" class="is"
            :class="showAway ? 'van-icon1' : ''" />
        </div>
      </div>
      <div class="table" v-if="showAway">
        <div class="left">
          <div class="label">选手</div>
          <div class="name" v-for="p in awayTeamPlayers" :key="'name' + p.playerId">【{{ p.number }}】{{ p.trueName }}</div>
        </div>
        <div class="right">
          <div class="label" v-if="active === 1">
            <span v-for="(item, i) in attachOptions" :key="'attach' + i">
              <div v-if="attachCheckboxes[item.label]"
                :style="{ background: getColor(attachOptions, attachCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 1">
            <div v-for="player in awayTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in attachOptions" :key="i">
                <div v-if="attachCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
          <div class="label" v-if="active === 2">
            <span v-for="(item, i) in pitchingOptions" :key="'pitching' + i">
              <div v-if="pitchingCheckboxes[item.label]"
                :style="{ background: getColor(pitchingOptions, pitchingCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 2">
            <div v-for="player in awayTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in pitchingOptions" :key="i">
                <div v-if="pitchingCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
          <div class="label" v-if="active === 3">
            <span v-for="(item, i) in catcherOptions" :key="'attach' + i">
              <div v-if="catcherCheckboxes[item.label]"
                :style="{ background: getColor(catcherOptions, catcherCheckboxes, i) }">{{ item.name }}</div>
            </span>
          </div>
          <div class="round" v-if="active === 3">
            <div v-for="player in awayTeamPlayers" :key="player.playerId" class="item">
              <span v-for="(item, i) in catcherOptions" :key="i">
                <div v-if="catcherCheckboxes[item.label]">{{ player[item.label] || 0 }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabs, Tab, Toast } from 'vant';
Vue.use(Tabs).use(Tab).use(Toast);
import { getBMMatchBaseBallStats, getBMMatchTeamPlayerBaseBallStats } from "@/api/match";
import { QNImageUtil } from "@/utils";
import { attachOptions, catcherOptions, pitchingOptions } from "@/config";

export default {
  props: {
    gameId: {
      required: true,
      default: ''
    },
    gameObj: {
      default: () => {}
    }
  },
  data() {
    return {
      typeOptions: [],
      is: true,
      players: [],
      showHome: true,
      awayTeam: {},
      showAway: true,
      homeTeamName: '',
      homeTeamBadge: '',
      awayTeamName: '',
      awayTeamBadge: '',
      homeScore: '',
      awayScore: '',
      gameSub: [],
      matchId: '',
      active: 1,
      attachCheckboxes: {},
      pitchingCheckboxes: {},
      catcherCheckboxes: {},
      attachOptions: attachOptions,
      pitchingOptions: pitchingOptions,
      catcherOptions: catcherOptions,
      homeTeamId: '',
      awayTeamId: '',
      homeTeamPlayers: [],
      awayTeamPlayers: [],
      gameMVPId: '',
      mvpObj: {}
    }
  },
  mounted() {
    this.getDate()
  },
  methods: {
    getDate() {
      const game = this.gameObj
      this.homeTeamId = game.homeTeamId
      this.awayTeamId = game.awayTeamId
      this.matchId = game.matchId
      this.gameSub = game.gameSub || []
      this.homeScore = game.homeScore
      this.awayScore = game.awayScore
      this.homeTeamName = game.homeTeamName
      this.awayTeamName = game.awayTeamName
      this.homeTeamBadge = game.homeTeamBadge
      this.awayTeamBadge = game.awayTeamBadge
      this.gameMVPId = game.gameMVPId
      this.getBMMatchBaseBallStats()
      this.getBMMatchTeamPlayerBaseBallStats()
    },
    getColor(options, object, index) {
      let num = 0
      for (let i = 0; i < index; i++) {
        if (object[options[i].label]) {
          num++
        }
      }
      return num % 2 === 0 ? '#0352E8' : '#1565FC'
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getBMMatchBaseBallStats() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchBaseBallStats(params).then(res => {
        if (res) {
          const { data } = res
          const typeOptions = []
          const bas = data.baseballAttachStats && data.baseballAttachStats.split('|') || []
          const attachCheckboxes = {}
          bas.forEach(psf => {
            attachCheckboxes[psf] = true
          })
          this.attachCheckboxes = attachCheckboxes
          if ('{}' !== JSON.stringify(this.attachCheckboxes)) {
            typeOptions.push({ value: 1, label: '进攻' })
          }
          const bps = data.baseballPitchingStats && data.baseballPitchingStats.split('|') || []
          const pitchingCheckboxes = {}
          bps.forEach(psf => {
            pitchingCheckboxes[psf] = true
          })
          this.pitchingCheckboxes = pitchingCheckboxes
          if ('{}' !== JSON.stringify(this.pitchingCheckboxes)) {
            typeOptions.push({ value: 2, label: '投手' })
          }
          const bcs = data.baseballCatcherStats && data.baseballCatcherStats.split('|') || []
          const catcherCheckboxes = {}
          bcs.forEach(psf => {
            catcherCheckboxes[psf] = true
          })
          this.catcherCheckboxes = catcherCheckboxes
          if ('{}' !== JSON.stringify(this.catcherCheckboxes)) {
            typeOptions.push({ value: 3, label: '接手' })
          }
          this.typeOptions = typeOptions
          this.active = typeOptions[0].value
        }
      })
    },
    getBMMatchTeamPlayerBaseBallStats() {
      const params = {
        matchId: this.matchId,
        gameId: this.gameId,
        pageSize: 999,
        pageNum: 1
      }
      getBMMatchTeamPlayerBaseBallStats(params).then(res => {
        if (res) {
          const { data } = res
          const players = data.list || []
          if (this.gameMVPId) {
            this.mvpObj = players.find(item => item.id === this.gameMVPId)
          }
          this.homeTeamPlayers = players.filter(p => {
            if (p.teamId !== this.homeTeamId) { // 不是球队成员直接pass
              return false
            }
            const bol = this.attachOptions.some(item => { // 是球队成员并且有比分
              return p[item.label] && p[item.label] != 0
            })
            return bol
          })
          this.awayTeamPlayers = players.filter(p => {
            if (p.teamId === this.awayTeamId) { // 不是球队成员直接pass
              return false
            }
            const bol = this.attachOptions.some(item => { // 是球队成员并且有比分
              return p[item.label] && p[item.label] != 0
            })
            return bol
          })
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
$width: 89px;

.big-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  color: #333333;
  padding: 25px 0 13px 0;
  margin: 0 16px;
  border-bottom: 0.5px #EEEEEE solid;

  .icon {
    width: 2px;
    height: 12px;
    background-color: #CF2F30;
    margin-right: 6px;
  }
}

.mvp {
  padding: 24px;
  background: linear-gradient(to bottom right, #FFF5C3, #ffffff);
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    margin-right: 14px;
  }

  .info {
    flex: 1;
  }

  .team-name {
    margin-top: 6px;
    font-size: 12px;
    color: #9A9A9A;
  }
}

.detail {
  .name {
    width: 150px;
  }

  .Total {
    width: 60px !important;
    min-width: 60px !important;
  }

  .game-sub {
    width: 40px !important;
    min-width: 40px !important;
  }
}

.collect {
  background: #F6F6F8;

  .team {
    div {
      font-size: 12px !important;
    }
  }

  .title {
    padding: 19px 16px 13px 16px;
    font-size: 14px;

    .name {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }

    .icon {
      color: #9A9A9A;

      .is {
        transition: 0.1s linear;
      }

      .van-icon1 {
        transform: rotateX(-180deg);
      }
    }
  }

  .table {
    padding-left: 16px;
    display: flex;

    .left {
      .label {
        min-width: $width;
        box-sizing: border-box;
        background: #1565FC;
        border-radius: 4px 0px 0px 0px;
        padding: 8px 0px 8px 24px;
        color: #fff;
        font-size: 14px;
        text-align: left;
      }

      .name {
        min-width: $width;
        height: 53px;
        box-sizing: border-box;
        text-align: center;
        background-color: #fff;
        border-bottom: 1px solid #E6E6E6;
        padding: 16px 0;
        font-size: 14px;
      }
    }

    .right {
      overflow: scroll;

      .label {
        display: flex;

        div {
          min-width: $width;
          box-sizing: border-box;
          text-align: center;
          background: #0352E8;
          color: #fff;
          font-size: 14px;
          padding: 8px 0;
        }
      }

      .round {

        // display: flex;
        .item {
          display: flex;

          div {
            height: 53px;
            font-size: 14px;
            min-width: $width;
            padding: 16px 0;
            background-color: #fff;
            border-bottom: 1px solid #E6E6E6;
            box-sizing: border-box;
            text-align: center;
          }
        }
      }
    }
  }
}</style>
